import { generateRandomString } from '../utils/stringHelper';
import { globalErrorHandler } from '../utils/errorHandler';
import { HttpClient } from '../utils/httpClient';

const PATH = {
    user: '/user',
    login: '/user/login',
    register: '/user/register',
    verify: '/user/whoami',
    logout: '/user/logout',
    changePassword: '/user/resetPassword',
    requestOtp: '/user/reqOtp',
    verifyOtp: '/user/verifyOtp',
    resetPassword: '/user/forgetPassword',
};

const login = async (payload, loader, error = globalErrorHandler) => {
    const { start, stop } = loader();

    start();

    try {
        const response = await HttpClient.post(PATH.login, payload);

        return response.data;
    } catch (err) {
        error(err);
        throw err;
    } finally {
        stop();
    }
};

const register = async (payload, loader, error = globalErrorHandler) => {
    const { start, stop } = loader();

    start();

    try {
        const response = await HttpClient.post(PATH.register, payload);

        return response.data;
    } catch (err) {
        error(err);
        throw err;
    } finally {
        stop();
    }
};

const verifyOtp = async (
    payload,
    loader,
    error = globalErrorHandler,
) => {
    const { start, stop } = loader();

    start();

    try {
        const response = await HttpClient.post(PATH.verifyOtp, payload);

        return response.data;
    } catch (err) {
        error(err);
        throw err;
    } finally {
        stop();
    }
};

const requestOtp = async (
    payload,
    loader,
    error = globalErrorHandler,
) => {
    const { start, stop } = loader();

    start();

    try {
        const response = await HttpClient.post(PATH.requestOtp, payload);

        return response.data;
    } catch (err) {
        error(err);
        throw err;
    } finally {
        stop();
    }
};

const resetPassword = async (
    payload,
    loader,
    error = globalErrorHandler,
) => {
    const { start, stop } = loader();

    start();

    try {
        const response = await HttpClient.post(PATH.resetPassword, payload);

        return response.data;
    } catch (err) {
        error(err);
        throw err;
    } finally {
        stop();
    }
};

const createUser = (
    payload,
    callback,
    error,
    loader,
) => {
    const { start, stop } = loader(generateRandomString(5));

    start();

    return HttpClient.post(`${PATH.user}`, payload).then(callback).catch(error).finally(stop);
};

const updateUser = (
    id,
    payload,
    callback,
    error,
    loader,
) => {
    const { start, stop } = loader(generateRandomString(5));

    start();

    return HttpClient.patch(`${PATH.user}/${id}`, payload).then(callback).catch(error).finally(stop);
};

const getUserDetails = (callback, error, loader,) => {
    const { start, stop } = loader(generateRandomString(5));
    start();
    return HttpClient.get(`${PATH.user}`).then(callback).catch(error).finally(stop);
};

const updateUserDetails = (payload, callback, error, loader,) => {
    const { start, stop } = loader(generateRandomString(5));
    start();
    return HttpClient.post(`${PATH.user}`, payload).then(callback).catch(error).finally(stop);
};

const addNewAddress = (payload, callback, error, loader,) => {
    const { start, stop } = loader(generateRandomString(5));
    start();
    return HttpClient.post(`${PATH.user}/address`, payload).then(callback).catch(error).finally(stop);
};


const changeUserStatus = (
    id,
    active,
    callback,
    error,
    loader,
) => {
    const { start, stop } = loader(generateRandomString(5));

    start();

    return HttpClient.get(`${PATH.user}/${id}/${active}`).then(callback).catch(error).finally(stop);
};

const verify = (
    callback,
    error,
    loader,
) => {
    const { start, stop } = loader(generateRandomString(5));

    start();

    return HttpClient.get(`${PATH.verify}`).then(callback).catch(error).finally(stop);
};

const logout = (callback, error, loader) => {
    const { start, stop } = loader(generateRandomString(5));

    start();

    return HttpClient.post(`${PATH.logout}`).then(callback).catch(error).finally(stop);
};

const changeUserPassword = (id, payload, callback, error, loader) => {
    const { start, stop } = loader(generateRandomString(5));

    start();

    return HttpClient.post(`${PATH.changePassword}/${id}`, payload)
        .then(callback)
        .catch(error)
        .finally(stop);
};

const createNewUser = (payload, callback, error, loader) => {
    const { start, stop } = loader(generateRandomString(5));

    start();

    return HttpClient.post(`${PATH.user}/create`, payload).then(callback).catch(error).finally(stop);
};

export const UserService = {
    login,
    verify,
    logout,
    getUserDetails,
    updateUserDetails,
    addNewAddress,

    changeUserPassword,
    updateUser,
    changeUserStatus,
    createUser,
    requestOtp,
    resetPassword,
    verifyOtp,
    createNewUser,
    register
};
